import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const AdminsContent = lazy(() => import('../../components/Pages/Admins'));

export default function Admins(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Admin List`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <AdminsContent />
      </Suspense>
    </Layout>
  );
}
